import React from 'react';
import './TermsAndConditions.css';

const TermsAndConditions = () => {
  return (
    <div className="TCcontainer">
      <div className='tcin'>
        <div className="TCheader">
          <h1>Terms & Conditions</h1>
          <p>Welcome to our online integrated platform for project uploads. Learn more about who we are and what we do.</p>
        </div>



        <div className="TCterms">


          <h3>1. Acceptance of Terms</h3>

          <p>By accessing and using [Platform Name] (the "Platform"), you agree to comply with and be bound by the following terms and conditions of use. If you do not agree with any part of these terms, you may not use the Platform.</p>

          <h3>2. User Registration</h3>

          <p>To access certain features of the Platform, you may be required to register an account. You agree to provide accurate and complete information during the registration process. You are responsible for maintaining the confidentiality of your account and password.</p>

          <h3>3. Project Uploads</h3>

          <p>(a) Users may upload projects, including but not limited to documents, images, and other relevant materials.

            (b) [Platform Name] reserves the right to review and remove any content that violates these terms or is deemed inappropriate.</p>

          <h3>4. Intellectual Property</h3>

          <p>(a) Users retain ownership of their uploaded projects.

            (b) By uploading projects, users grant [Platform Name] a non-exclusive, royalty-free license to use, display, and distribute the content on and through the Platform.</p>

          <h3>5. Privacy</h3>

          <p>(a) [Platform Name] respects user privacy. Please refer to our Privacy Policy for details on how personal information is collected, used, and protected.</p>

          <h3>6. Prohibited Conduct</h3>

          <p>(a) Users agree not to engage in any conduct that violates applicable laws or the rights of others.

            (b) Prohibited conduct includes, but is not limited to, uploading malicious software, spamming, and engaging in illegal activities.</p>

          <h3>7. Security</h3>

          <p>(a) Users are responsible for maintaining the security of their accounts.

            (b) Users must promptly notify [Platform Name] of any unauthorized access or security breaches.</p>

          <h3>8. Termination</h3>

          <p>[Platform Name] reserves the right to terminate or suspend access to the Platform, with or without cause, at its sole discretion.</p>

          <h3>9. Disclaimer of Warranties</h3>

          <p>(a) The Platform is provided "as is" and without any warranty of any kind, whether express or implied.

            (b) [Platform Name] makes no representations or warranties regarding the accuracy, completeness, or reliability of any content on the Platform.</p>

          <h3>10. Limitation of Liability</h3>

          <p>(a) [Platform Name] shall not be liable for any direct, indirect, incidental, consequential, or punitive damages arising out of or in connection with the use or inability to use the Platform.</p>

          <h3>11. Modifications to Terms</h3>

          <p>[Platform Name] reserves the right to modify these terms at any time. Users are responsible for regularly reviewing the terms.</p>



        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;
